import { render, staticRenderFns } from "./back-clue.pug?vue&type=template&id=66640e7e&lang=pug&"
import script from "./back-clue.ts?vue&type=script&lang=ts&"
export * from "./back-clue.ts?vue&type=script&lang=ts&"
import style0 from "./back-clue.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports